module.exports = __webpack_public_path__ + "img/facematch-live.f9b2d801.png";